import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { QrCodeIcon, TruckIcon, ZapIcon, ShieldCheckIcon } from 'lucide-react';
export function Hero() {
  const [provisionMode, setProvisionMode] = useState<'esim' | 'physical'>('esim');
  return <section className="relative pt-24 pb-16 bg-[#13E200]" data-id="element-124">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-125">
        <div className="grid lg:grid-cols-2 gap-12 items-center" data-id="element-126">
          <div className="py-12" data-id="element-127">
            <h1 className="text-5xl lg:text-7xl font-black tracking-tighter text-black mb-6 leading-tight uppercase" data-id="element-128">
              Switch to Effy <br data-id="element-129" />
              <span className="bg-black text-white px-4 py-1 inline-block mt-2" data-id="element-130">
                Get More AI
              </span>
            </h1>
            <p className="text-xl text-black font-bold mb-10 max-w-xl leading-relaxed" data-id="element-131">
              Effy Mobile routes your talk, text, and 5G data over native
              nationwide VoLTE cellular towers. No signal drops. Every line
              drops straight into a cloud automation matrix.
            </p>

            <div className="flex flex-wrap gap-4" data-id="element-132">
              <button className="cricket-btn-secondary !text-lg !px-12 !py-4" data-id="element-133">
                Shop Plans
              </button>
              <button className="bg-white text-black font-bold py-4 px-12 rounded-full hover:bg-gray-100 transition-all uppercase tracking-wide text-lg border-2 border-black" data-id="element-134">
                Find a Store
              </button>
            </div>
          </div>

          <div className="relative hidden lg:block" data-id="element-135">
            <div className="bg-white rounded-3xl p-8 shadow-2xl border-4 border-black" data-id="element-136">
              <div className="flex p-1 bg-gray-100 rounded-full mb-8 w-fit mx-auto border border-gray-200" data-id="element-137">
                <button onClick={() => setProvisionMode('esim')} className={`px-6 py-2 rounded-full text-xs font-bold uppercase tracking-wider transition-all ${provisionMode === 'esim' ? 'bg-[#13E200] text-black shadow-md' : 'text-gray-500 hover:text-black'}`} data-id="element-138">
                  eSIM Instant
                </button>
                <button onClick={() => setProvisionMode('physical')} className={`px-6 py-2 rounded-full text-xs font-bold uppercase tracking-wider transition-all ${provisionMode === 'physical' ? 'bg-[#13E200] text-black shadow-md' : 'text-gray-500 hover:text-black'}`} data-id="element-139">
                  SIM Kit
                </button>
              </div>

              <AnimatePresence mode="wait" data-id="element-140">
                {provisionMode === 'esim' ? <motion.div key="esim" initial={{
                opacity: 0,
                y: 10
              }} animate={{
                opacity: 1,
                y: 0
              }} exit={{
                opacity: 0,
                y: -10
              }} className="text-center" data-id="element-141">
                    <div className="w-48 h-48 bg-gray-50 p-4 rounded-2xl mx-auto mb-6 flex items-center justify-center border-2 border-dashed border-gray-300" data-id="element-142">
                      <QrCodeIcon className="w-full h-full text-black opacity-80" data-id="element-143" />
                    </div>
                    <h3 className="text-2xl font-black mb-2 text-black uppercase tracking-tighter" data-id="element-144">
                      Scan to Activate
                    </h3>
                    <p className="text-gray-500 text-sm font-bold uppercase tracking-widest" data-id="element-145">
                      Ready in 60 Seconds
                    </p>
                  </motion.div> : <motion.div key="physical" initial={{
                opacity: 0,
                y: 10
              }} animate={{
                opacity: 1,
                y: 0
              }} exit={{
                opacity: 0,
                y: -10
              }} data-id="element-146">
                    <div className="bg-gray-50 rounded-2xl p-6 mb-6 border border-gray-200" data-id="element-147">
                      <div className="flex justify-between items-center mb-6" data-id="element-148">
                        <div className="flex items-center gap-3" data-id="element-149">
                          <div className="w-10 h-10 bg-[#13E200]/10 rounded-lg flex items-center justify-center border border-[#13E200]/20" data-id="element-150">
                            <TruckIcon className="w-5 h-5 text-[#13E200]" data-id="element-151" />
                          </div>
                          <div data-id="element-152">
                            <p className="text-[10px] text-gray-400 font-black uppercase tracking-widest" data-id="element-153">
                              Tracking
                            </p>
                            <p className="text-sm font-mono text-black font-bold" data-id="element-154">
                              EFFY-9928-XJ
                            </p>
                          </div>
                        </div>
                        <span className="px-2 py-1 bg-black text-white text-[10px] font-black rounded uppercase tracking-widest" data-id="element-155">
                          Shipped
                        </span>
                      </div>

                      <div className="space-y-4" data-id="element-156">
                        {[{
                      label: 'Order Processed',
                      active: true
                    }, {
                      label: 'Kit Provisioned',
                      active: true
                    }, {
                      label: 'Out for Delivery',
                      active: false
                    }].map((step, i) => <div key={i} className="flex items-center gap-4" data-id="element-157">
                            <div className={`w-2 h-2 rounded-full ${step.active ? 'bg-[#13E200]' : 'bg-gray-300'}`} data-id="element-158" />
                            <p className={`text-xs font-bold uppercase tracking-widest ${step.active ? 'text-black' : 'text-gray-400'}`} data-id="element-159">
                              {step.label}
                            </p>
                          </div>)}
                      </div>
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>

            {/* Mascot */}
            <div className="absolute -bottom-6 -right-6 w-24 h-24" data-id="element-160">
              <img src="https://api.dicebear.com/7.x/bottts/svg?seed=efe&backgroundColor=13e200" alt="Efe" className="w-full h-full drop-shadow-lg" data-id="element-161" />
            </div>
          </div>
        </div>
      </div>
    </section>;
}